function copyToClipboard(content: string): boolean
{
    try
    {
        const el          = document.createElement('textarea');
        el.value          = content;
        el.style.position = 'absolute';
        el.style.left     = '-9999px';
        el.setAttribute('readonly', '');
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
    catch (e)
    {
        return false;
    }

    return true;
}

function clearSelection()
{
    const selection = window.getSelection();

    if (!selection)
    {
        return;
    }

    if (selection.empty)
    {  // Chrome
        selection.empty();
    }
    else if (selection.removeAllRanges)
    {  // Firefox
        selection.removeAllRanges();
    }
}

function copyNodeToClipboard(node: Node): boolean
{
    const range = document.createRange();
    range.selectNode(node);

    const selection = window.getSelection();

    if (!selection)
    {
        return false;
    }

    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    clearSelection();

    return true;
}

function copyLinkElementToClipboard(href: string, text: string): Promise<void>
{
    return new Promise((resolve, reject) =>
    {
        let a = document.createElement('a');

        a.setAttribute('href', href);
        a.setAttribute('target', '_blank');
        a.innerText = text;

        document.body.append(a);

        if (copyNodeToClipboard(a))
        {
            resolve();
        }
        else
        {
            reject();
        }

        a.remove();
    });
}

function copyContentToClipboard(element: HTMLElement): boolean
{
    return copyToClipboard(element.innerText);
}

function copyHTMLToClipboard(element: HTMLElement): boolean
{
    return copyToClipboard(element.innerHTML);
}

export {
    copyToClipboard,
    copyNodeToClipboard,
    copyContentToClipboard,
    copyHTMLToClipboard,
    copyLinkElementToClipboard,
};